import { type FC, type ReactNode } from 'react';

import { LayoutBlock } from 'shared/components/LayoutBlock';

import styles from './MortgageSection.css';

export interface IMortgageSectionProps {
  children: ReactNode;
  tabs: ReactNode;
  title: string;
  onView: () => void;
}

export const MortgageSection: FC<IMortgageSectionProps> = ({ children, tabs, title, onView }) => {
  return (
    <LayoutBlock id="mortgage-section" title={title} onView={onView}>
      <div className={styles['container']}>
        {tabs}
        {children}
      </div>
    </LayoutBlock>
  );
};
